export default __webpack_public_path__ + "static/media/fillPatternEmpty.f80b5c25.svg";